import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "../../factories/bao-dialog";
import * as moment from "moment";
/*
 * View model for editing shiftbook relations with shift pattern
 * */
class ShiftbookShiftPlanModelDialog {
    Bao = Bao;
    Dialog: BaoDialog;
    Parent: any;
    public Model: any;

    ShiftbookShiftPlanModelId: KnockoutObservable<string> = ko.observable("");
    ShiftPlanModelId: KnockoutObservable<string> = ko.observable("");
    ShiftPlanModelName: KnockoutObservable<string> = ko.observable("");
    StartDateJs: KnockoutObservable<string> = ko.observable("");
    StartTime: KnockoutObservable<string> = ko.observable("");
    StartTimeModel: KnockoutObservableArray<{ StartTime: string }> = ko.observableArray([]);
    AppendHours: KnockoutObservable<number> = ko.observable(null);
    AppendHoursModel: KnockoutObservableArray<{ Key: number, Value: string }> = ko.observableArray([]);
    IsEnabledStartTime: KnockoutObservable<boolean> = ko.observable(false);

    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        data.Parent.ItemCompleteCheck = this.ItemCompleteCheck;

        let startTimeOnStart = this.StartTime();

        this.AppendHoursModel(data.Parent.AppendHoursModel());
        this.SetStartTime().then(_ => this.StartTime(startTimeOnStart));

        this.ShiftPlanModelId.subscribe(value => {
            this.SetStartTime();
        });

        this.AppendHours.subscribe(value => {
            this.SetStartTime();
        });

        this.StartDateJs.subscribe(value => {
            this.SetStartTime();
        });
    }


    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        let result = true;

        if (Bao.Utils.String.IsNullOrWhitespace(item.ShiftPlanModelId())) {
            result = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(item.StartDateJs())) {
            result = false;
        }
        if (item.StartTime() === null || item.StartTime() === undefined) {
            result = false;
        }
        if (item.AppendHours() === null || item.AppendHours() === undefined) {
            result = false;
        }

        if (!result) {
            let def = $.Deferred<boolean>();
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            def.resolve(result);
            return def.promise();
        }
        else {
            return this.ValidateNewStartDate(item);
        }
    }

    private ValidateNewStartDate(item: any): JQueryPromise<boolean> {
        this.Parent.TabPage.IsLoading(true);

        return Bao.post('ShiftbookShiftPlanModel/ValidateNewStartDate',
            JSON.stringify({ sessionTabId: this.Parent.SessionTabId, parentId: this.Parent.GetParentId(), shiftbookShiftPlanModelId: item.ShiftbookShiftPlanModelId(), newStartDateJs: this.StartDateJs() }))
            .then((result) => {
                if (!result.Result) {
                    Bao.Session.GetMessage("msgNextShiftPatternForShiftbook").then((message) => {
                        new BaoDialog(Bao.Session.ApplicationName, message.replace('{0}', moment.duration(result.MaxAllowed, "minutes").humanize()), "info");
                    });
                    return false;
                }

                return true;
            })
            .always(() => {
                this.Parent.TabPage.IsLoading(false);
            });
    }

    private SetStartTime(): JQueryPromise<void> {
        if (this.ShiftPlanModelId() && this.AppendHours() !== null && this.StartDateJs()) {
            this.Parent.TabPage.IsLoading(true);
            return Bao.post('ShiftbookShiftPlanModel/GetStartTimeModel',
                JSON.stringify({ sessionTabId: this.Parent.SessionTabId, parentId: this.Parent.GetParentId(), shiftbookShiftPlanModelId: this.ShiftbookShiftPlanModelId(), shiftPlanModelId: this.ShiftPlanModelId(), appendHours: this.AppendHours(), startDateJs: this.StartDateJs() }))
                .then((result) => {
                    if (result && result.Result) {
                        this.IsEnabledStartTime(true);
                        this.StartTimeModel(result.Model);
                    }
                    else {
                        new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                    }
                })
                .always(() => {
                    this.Parent.TabPage.IsLoading(false);
                });
        }
        else {
            this.StartTime(null);
            this.StartTimeModel([]);
            this.IsEnabledStartTime(false);
            return $.Deferred<void>().resolve().promise();
        }
    }
}
export default ShiftbookShiftPlanModelDialog;